<!-- This component exists as a place where we can build the coverImageDefault object and then pass to the ManuscriptCoverModern component. -->
<template>
    <ManuscriptCoverModern
        :cover_image="coverImageDefault"
        :class="coverSizeCssClass"
    />
</template>

<script>
import ManuscriptCoverModern from "@shared/manuscript-cover/ManuscriptCoverModern.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    components: { ManuscriptCoverModern },

    props: ["cover_image", "title", "author_name"],

    computed: {
        ...mapState(useSubmissionWizardStore, ["form_type"]),

        coverImageDefault() {
            return {
                type: "default",
                data: {
                    image_url: this.cover_image.image_url,
                    css_class: this.cover_image.class,
                    title: this.title,
                    author_name: this.author_name,
                },
            };
        },

        coverSizeCssClass() {
            if (this.form_type == "simple") return "size-4"; // 285px

            if (this.form_type == "elaborate") return "size-3"; // 227px

            return "size-3"; // Default to this value. Explicit (redundant) by choice.
        },
    },
};
</script>
